var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-box"},[_c('figure',{staticClass:"image",class:_vm.data.imageObjectFit},[_c('img',{attrs:{"src":_vm.data.avatar}})]),_c('div',{staticClass:"text"},[_c('h5',{staticClass:"user-title"},[_vm._v(_vm._s(_vm.data.full_name))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.data.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }